import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import placeholderImage from "../images/Placeholder.png";
import { API_BASE_URL } from '../config';

function SignUp() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [toggledPassword, setToggledPassword] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg(false);

    // Client-side validations for email and password criteria
    if (!email || !email.includes("@")) {
      setErrorMsg("Invalid email. Please enter a valid email address.");
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setErrorMsg("Passwords entered do not match. Please try again.");
      setLoading(false);
      return;
    }

    if (!password || password.length < 8) {
      setErrorMsg("Password must be at least 8 characters long.");
      setLoading(false);
      return;
    }

    if (!/\d/.test(password)) {
      setErrorMsg("Password must include at least one number.");
      setLoading(false);
      return;
    }

    if (!/[^A-Za-z0-9]/.test(password)) {
      setErrorMsg("Password must include at least one special character.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/register`, { firstName, lastName, email, password }, {
        withCredentials: true,
      });

      if (response.status === 201) {
        setSuccessMsg(response?.data?.message || "Account created successfully.");
      }
    } catch (error) {
      console.error(error);
      const serverMsg = error.response?.data?.message;
      if (serverMsg) {
        setErrorMsg(serverMsg);
      } else if (error.message && error.message.includes("404")) {
        setErrorMsg("Server error. Please try again later.");
      } else {
        setErrorMsg(error.message || "An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <section style={{ margin: "3rem 5rem" }}>
      <h1 className="centered-subtitle">Create an account</h1>
      <section className="log-in-container">

        <form className="log-in-form" onSubmit={handleSubmit}>
          {errorMsg && <div className="log-in-error">* {errorMsg}</div>}
          {successMsg && <div className="log-in-success">* {successMsg}</div>}
          <div className="log-in-name-container">
            <div className="log-in-name-subcontainer">
              <label>First Name</label>
              <input
                type="text"
                className="form-control"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="log-in-name-subcontainer">
              <label>Last Name</label>
              <input
                type="text"
                className="form-control"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required

              /></div>
          </div>

          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required

          />

          <label>Password</label>
          <div>
            <input
              type={toggledPassword ? "text" : "password"}
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button className="log-in-reveal-button" type="button" onClick={() => { setToggledPassword(!toggledPassword) }}><i className={`bi ${toggledPassword ? "bi-eye-slash" : "bi-eye"}`}></i></button>
          </div>
          <label>Confirm Password</label>
          <div>
            <input
              type={toggledPassword ? "text" : "password"}
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button className="log-in-reveal-button" type="button" onClick={() => { setToggledPassword(!toggledPassword) }}><i className={`bi ${toggledPassword ? "bi-eye-slash" : "bi-eye"}`}></i></button>
          </div>
          <div className="sign-up-password-criteria-container">
            <p>Your password should meet the following criteria: </p>
            <ul className="sign-up-password-criteria-subcontainer" style={{ fontWeight: "lighter" }}>
              <li>8+ Characters <span style={{ fontWeight: "light", fontStyle: "italic", color: "gray" }}>abc...</span></li>
              <li>1+ Special Character(s) <span style={{ fontWeight: "light", fontStyle: "italic", color: "gray" }}>!@#$...</span></li>
              <li>1+ Number(s) <span style={{ fontWeight: "light", fontStyle: "italic", color: "gray" }}>123...</span></li>

            </ul>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Creating your account..." : "Sign Up"}
          </button>
          <p>Already have an account? <Link to="/log-in">Log In</Link></p>
          <small>By creating an account, you are agreeing to our <Link to="/Terms-of-service">Terms of Service</Link> and our <Link to="/Privacy-policy">Privacy Policy</Link>.</small>
          {/* <button type="button">Test</button> */}
        </form>



      </section>

    </section>
  );
}

export default SignUp;